import * as React from 'react'
import {Link} from "gatsby";

const Overlay = () => {
    return (
        <div className="ort">
            <div className="information">
                <div className="image" id="image">
                    <img alt="" className="ort-img dummy" src={"/images/Logo_ODD.svg"}/>                
                </div>
                <div className="row">
                    <div className="col-12">
                        <h2>
                            Mödlareuth    
                        </h2>
                    </div>
                </div>
                <p>
Das ab 1949 durch die Grenze zwischen Diktatur und Demokratie geteilte Dorf („Little Berlin“) wurde zum Symbol der deutsch-deutschen Teilung und hält die Erinnerung daran seit 1990 wach.
</p>
            </div>
                <Link to="/neue-Orte/" className='ort-text icon-arrow-right load-infobox'>
                Mehr erfahren
            </Link>

        </div>
    )
}

export default Overlay

